/* Just Silver - all collections (quiet luxury).
   Group filter, count-up, word-by-word title, reveals and the ghost word.
   Without this file every tile is a plain link and both groups show. */
(function () {
  'use strict';

  var d = document;
  var w = window;
  var root = d.querySelector('[data-jsq-collections]');
  if (!root) return;
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var anim = !reduce && !design && ('IntersectionObserver' in w);

  /* ---------- title ---------- */
  var title = $('[data-jsq-split]');
  if (title) {
    var n = 0;
    var wrap = function (text, into) {
      text.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { into.appendChild(d.createTextNode(' ')); return; }
        var o = d.createElement('span');
        o.className = 'jsq-w';
        o.style.setProperty('--w', n);
        n += 1;
        var i = d.createElement('span');
        i.textContent = part;
        o.appendChild(i);
        into.appendChild(o);
      });
    };
    var nodes = Array.prototype.slice.call(title.childNodes);
    title.textContent = '';
    nodes.forEach(function (node) {
      if (node.nodeType === 3) { wrap(node.textContent, title); return; }
      var shell = node.cloneNode(false);
      wrap(node.textContent, shell);
      title.appendChild(shell);
    });
    title.classList.add('is-split');
    if (anim) setTimeout(function () { title.classList.add('is-in'); }, 40);
    else title.classList.add('is-in');
  }

  /* ---------- count-up ---------- */
  var count = $('[data-jsq-count]');
  if (count && !reduce) {
    var end = parseInt(count.textContent, 10);
    if (end > 0) {
      var start = Date.now() + 300;
      count.textContent = '0';
      var tick = function () {
        var t = Math.min(1, Math.max(0, (Date.now() - start) / 1400));
        count.textContent = Math.round(end * (1 - Math.pow(1 - t, 3)));
        if (t < 1) setTimeout(tick, 32);
      };
      setTimeout(tick, 300);
    }
  }

  /* ---------- filter ---------- */
  var groups = $$('.jsq-cl__group');
  var buttons = $$('[data-jsq-filter] button');
  buttons.forEach(function (b) {
    b.addEventListener('click', function () {
      var show = b.getAttribute('data-show');
      buttons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      groups.forEach(function (g) {
        var on = show === 'all' || g.getAttribute('data-group') === show;
        var was = !g.hidden;
        g.hidden = !on;
        if (on) {
          $$('[data-jsq-pop]', g).forEach(function (x) { x.classList.add('is-in'); });
          if (anim && (!was || show !== 'all')) {
            g.classList.remove('is-entering');
            void g.offsetWidth;
            g.classList.add('is-entering');
          }
        }
      });
      var first = groups.filter(function (g) { return !g.hidden; })[0];
      if (first && first.getBoundingClientRect().top < 0) first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ---------- reveals ---------- */
  var pops = $$('[data-jsq-pop]');
  if (anim && pops.length) {
    var fold = w.innerHeight * 0.95;
    var later = [];
    pops.forEach(function (x) {
      var r = x.getBoundingClientRect();
      if ((r.top < fold && r.bottom > 0) || (r.width === 0 && r.height === 0)) x.classList.add('is-in');
      else later.push(x);
    });
    root.classList.add('jsq-pol--anim');
    var heard = false;
    var io = new IntersectionObserver(function (entries) {
      heard = true;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    later.forEach(function (x) { io.observe(x); });
    setTimeout(function () {
      if (!heard) { later.forEach(function (x) { x.classList.add('is-in'); }); io.disconnect(); }
    }, 3000);
  } else {
    pops.forEach(function (x) { x.classList.add('is-in'); });
  }

  /* ---------- ghost word ---------- */
  var hero = $('.jsq-pol__hero');
  var ghost = $('[data-jsq-ghost]');
  if (hero && ghost && !reduce && !design) {
    var onScroll = function () {
      var hr = hero.getBoundingClientRect();
      if (hr.bottom > 0) ghost.style.setProperty('--gx', Math.round(Math.max(0, -hr.top) * 0.35));
    };
    w.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
